import { Card, CardContent, CardHeader, CardTitle } from "../components/ui/card";
import { CreditCard, DollarSign } from "lucide-react";

export default function Payments() {
  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold">Payments</h1>
      <Card className="bg-zinc-900 border-zinc-800">
        <CardContent className="py-12 text-center">
          <DollarSign className="h-16 w-16 mx-auto text-zinc-600 mb-4" />
          <p className="text-zinc-400">Payment processing coming soon</p>
        </CardContent>
      </Card>
    </div>
  );
}
